import { useBemCN } from '@gik/core/utils/bemBlock';
import type { TabDefinition } from '@gik/ui-legacy/TabbedView';
import { TabbedView } from '@gik/ui-legacy/TabbedView';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryClaimsList } from './HistoryClaimsList';
import { UpcomingClaimsList } from './UpcomingClaimsList';
import { translationKeys } from './i18n/en';

const blockName = 'claimed-items';

export type IClaimedItemsProps = {};

export default function ClaimedItems() {
  const { t } = useTranslation();
  const bem = useBemCN(blockName);

  const tabs: TabDefinition[] = React.useMemo(
    () => [
      {
        title: t(translationKeys.claimed),
        content: <UpcomingClaimsList />,
      },
      {
        title: t(translationKeys.history),
        content: <HistoryClaimsList />,
      },
    ],
    [t]
  );

  return <TabbedView {...bem()} tabs={tabs} />;
}
